// extracted by mini-css-extract-plugin
export default {"wrapper":"Navigation_wrapper__vKHUi","icon":"Navigation_icon__lPT0N","themeIcon":"Navigation_themeIcon__hUk7m"};